'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageQuery = pageQuery;

var _requestOlympics = require('@ali/request-olympics');

var _requestOlympics2 = _interopRequireDefault(_requestOlympics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *判断返回值
 * @param {Object} res 返回值
 * @returns Promise.reject or Promise.resolve
 */
function resErrorJudge(res) {
  if (!res || !res.success) {
    return Promise.reject(res);
  }
  return Promise.resolve(res.data);
}

function pageQuery() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var keyword = arguments[2];
  var propertyCode = arguments[3];

  return _requestOlympics2.default.get('//mocks.alibaba-inc.com/mock/U2lzuFDV/form/asyncOptions', {
    params: {
      page: page,
      count: count,
      keyword: keyword,
      propertyCode: propertyCode
    }
  }).then(resErrorJudge);
}